export class CustomError extends Error {
  constructor(error, ...params) {
    super(...params);
    const message = error && error.message ? error.message : "";
    this.message = message;
    /* istanbul ignore next */
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError);
    }
    this.originalError = error;
  }
}
